import Filter       from './Design/Filter.es6';
import Configurator from './Design/Configurator.es6';
import Proposals    from "./Design/Proposals.es6";

class Design {
    constructor() {
        this.render();
        this.preload().then(() => {
            this.Configurator   = new Configurator(this);
            this.Proposals      = new Proposals(this);
            this.Configurator.Observer.register(() => this.update());
            // Expose
            window.Design       = this;
            // De-Activate Filter
            if (App.Variable('useFilter')) this.Filter = new Filter(this);
            this.bind();
        });
    }

    preload() {
        return Promise.all([
            App.Components.wait('.js-display'),
            App.Components.wait(App.Components.selector('product-summary')),
            App.Endpoint.Designs.get,
        ]).then(values => {
            this.Tin        = values.shift();
            this.Summary    = values.shift();
        });
    }

    // Getters
    get container() { return document.getElementById('js-mixer-design-container') }
    get product()   { return App.Variable('product') }
    get design()    { return App.Endpoint.Designs.getById(this.Configurator.id) }
    get instance () { return App.Variable('instance') }
    get values()    {
        const Configurator = this.Configurator;
        const text = Configurator.Progress.get('text').values;
        return {
            productId:      this.product,
            name:           text.name,
            description:    text.description,
            design:         Configurator.id,
            instance:       this.instance,
        }
    }

    // Url params to call (some) steps
    get post() {
        return {
            muesli_name:        this.values.name,
            muesli_description: this.values.description,
            design:             this.values.design,
        }
    }

    get dummy() {
        return App.Variable('dummy');
    }

    bind() {
        window.addEventListener('resize', this.render);
    }

    async assignParams(url) {
        const design = await this.design;
        if (this.product)   url.searchParams.append("product", this.product);
        if (design.id)      url.searchParams.append("design", design.id);
        return url;
    }

    async back() {
        const url = await this.assignParams(new URL(App.Route('mixer'), window.location.origin));
        window.location.href = url.href;
    }

    async remove() {
        const design = await App.Endpoint.Designs.default();
        this.setId(design.id);
    }

    async information() {
        const url = await this.assignParams(new URL('/mixer/design/view/information', window.location.origin));
        App.Components.Popup.showXMLHttpRequestContent(url.href);
    }

    setId(id) {
        if (!this.Configurator) return; // @todo: find case when `configurator is not set
        if (id === 'start-configuration') {
            this.Configurator.start('upload');
        } else {
            this.Configurator.Progress.get('selector').save(id);
            this.select(id);
            this.update();
            if (App.Interface.Utilities.isMobile()) this.Configurator.next();
        }
    }

    select(id) {
        document.querySelectorAll('.design-selector-item').forEach(element => element.classList.remove('active'));
        const select = document.querySelector('.design-selector-item[data-id="' + id + '"]');
        if (select) {
            select.classList.add('active');
        }
    }

    get price() {
        return App.Variable('iddPrice');
    }

    get result() {
        return this.Filter ? this.Filter.result : App.Endpoint.Designs.getIDCDesigns();
    }

    async b2bInfo() {
        const productInfo = await App.Interface.Product.getFormatedValues(this.product, this.Configurator.id);
        App.Components.Popup.showXMLHttpRequestContent('/b2b/discount?value=' + productInfo.price);
    }

    async render () {
        // Calculate the space from header and button and expand vertically
        let top = document.querySelector('.mixer-design-wrap').offsetTop + 5;
        this.container?.style.setProperty('--frameSpace', top + 'px');
    }

    async update() {
        const standard  = await App.Endpoint.Designs.default();
        const design    = await this.design;
        this.container.dataset.designType = standard.id === this.Configurator.id ? 'default' : 'custom';
        this.container.classList.toggle('has-design-filter', this.Filter !== undefined);
        this.Summary.set(App.Variable('product'), this.Configurator.id || standard.id).update();
        this.Tin.setDesign(this.Configurator.id || standard.id);
        this.container.querySelectorAll('.js-design-price').forEach(element => element.innerHTML = design.priceFormatted);
    }

    async submit() {
        if (this.Configurator.Progress.current?.stopOnSubmit) {
            this.Configurator.Progress.update();
        } else {
            App.Interface.Notification.reset();
            switch (App.Interface.Mix.updateValues(this.product, this.post)) {
                case 403:
                    App.Interface.Notification.add('floating', __('DEFAULT.404.TEXT')).update();
                    break;
                default:
                    this.Configurator.data = {};
                    window.location.href = App.Route('shop.cart');
            }
        }
    }
}
new Design();
